import type { ArticleMediaComponent } from '@twisto/api-cms'

import { StrapiMedia } from '../../atoms'

import * as styles from './media.styles'

export const Media = ({ src }: ArticleMediaComponent) => {
  const attributes = src ?? null

  if (attributes == null) {
    return null
  }

  return <StrapiMedia {...attributes} css={styles.media} />
}
